import { InjectionToken } from '@angular/core';
import { Observable, of } from 'rxjs';

export const SNACKBAR_DEFAULT_EXPIRATION_MS = 5000;

export const SNACKBAR_DEFAULT_EXPIRATION = new InjectionToken<Observable<number | undefined>>('SNACKBAR_DEFAULT_EXPIRATION', {
  providedIn: 'root',
  factory: (): Observable<number> => of(SNACKBAR_DEFAULT_EXPIRATION_MS),
});
